import script from "./ComputeWizardSurface.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardSurface.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardSurface.vue?vue&type=style&index=0&id=126e3eee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126e3eee"]])

export default __exports__